import {
  CaretRightIcon,
  CheckIcon,
  TagIcon,
  XIcon,
} from "@phosphor-icons/react";
import { useState, useEffect, useRef } from "react";
import settings from "./settings";

export const CheckoutSummary = ({
  subTotal = "",
  total = "",
  cart = null,
  applyCoupon,
  removeCoupon,
  applyNote,
  removeNote,
  couponLoading = false,
  noteLoading = false,
}) => {
  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const textColor = settings.textColor.value;
  const labelColor = settings.labelColor.value;
  const totalTextColor = settings.totalTextColor.value;
  const buttonBackgroundColor = settings.buttonBackgroundColor.value;
  const buttonTextColor = settings.buttonTextColor.value;
  const inputBackgroundColor = settings.inputBackgroundColor.value;
  const inputBorderColor = settings.inputBorderColor.value;
  const dividerColor = settings.dividerColor.value;
  const iconColor = settings.iconColor.value;
  const padding = settings.padding.value + "px";
  const borderRadius = settings.borderRadius.value + "px";
  const subtotalFontSize = settings.subtotalFontSize.value + "px";
  const totalFontSize = settings.totalFontSize.value + "px";
  const labelFontSize = settings.labelFontSize.value + "px";
  const inputFontSize = settings.inputFontSize.value + "px";
  const buttonFontSize = settings.buttonFontSize.value + "px";
  const subtotalFontWeight = settings.subtotalFontWeight.value;
  const totalFontWeight = settings.totalFontWeight.value;
  const headerFontWeight = settings.headerFontWeight.value;
  const iconSize = settings.iconSize.value;
  const inputBorderRadius = settings.inputBorderRadius.value + "px";
  const buttonBorderRadius = settings.buttonBorderRadius.value + "px";
  const inputPadding = settings.inputPadding.value + "px";
  const buttonPadding = settings.buttonPadding.value + "px";
  const sectionGap = settings.sectionGap.value + "px";
  const itemGap = settings.itemGap.value + "px";
  const textareaHeight = settings.textareaHeight.value + "px";
  const animationDuration = settings.animationDuration.value + "ms";
  const showDividers = settings.showDividers.value;
  const showIcons = settings.showIcons.value;
  const collapsibleSections = settings.collapsibleSections.value;
  const subtotalLabel = settings.subtotalLabel.value;
  const totalLabel = settings.totalLabel.value;
  const couponAddLabel = settings.couponAddLabel.value;
  const couponEditLabel = settings.couponEditLabel.value;
  const noteAddLabel = settings.noteAddLabel.value;
  const noteEditLabel = settings.noteEditLabel.value;
  const couponPlaceholder = settings.couponPlaceholder.value;
  const notePlaceholder = settings.notePlaceholder.value;
  const applyButtonText = settings.applyButtonText.value;
  const loadingText = settings.loadingText.value;

  const [couponOpen, setCouponOpen] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [noteText, setNoteText] = useState("");
  const [existingCoupons, setExistingCoupons] = useState([]);
  const [existingNote, setExistingNote] = useState("");

  const couponInputRef = useRef(null);
  const noteInputRef = useRef(null);

  useEffect(() => {
    if (cart) {
      if (cart.couponCode) {
        setExistingCoupons(true);
        setCouponCode(cart.couponCode);
      } else {
        setExistingCoupons(false);
        setCouponCode("");
      }

      if (cart.note) {
        setExistingNote(cart.note);
        setNoteText(cart.note);
      } else {
        setExistingNote("");
        setNoteText("");
      }
    }
  }, [cart]);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim() || !applyCoupon) return;

    const result = await applyCoupon(couponCode, existingCoupons);
    if (result.success) {
      setCouponOpen(false);
    }
  };

  const handleRemoveCoupon = async (codeToRemove) => {
    if (!removeCoupon) return;

    const result = await removeCoupon(codeToRemove, existingCoupons);
    if (result.success) {
      setCouponCode("");
      setExistingCoupons([]);
      setCouponOpen(false);
    }
  };

  const handleApplyNote = async () => {
    if (!noteText.trim() || !applyNote) return;

    const result = await applyNote(noteText);
    setNoteOpen(false);
  };

  const handleRemoveNote = async () => {
    if (!removeNote) return;

    const result = await removeNote();
    setNoteText("");
    setExistingNote("");
    setNoteOpen(false);
  };

  const hasExistingCoupons = existingCoupons.length > 0;
  const hasExistingNote = cart?.giftPackageNote;
  const loading = couponLoading || noteLoading;

  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        padding: padding,
        borderRadius: borderRadius,
        margin: "0 auto",
        fontFamily: "sans-serif",
        color: textColor,
      }}
    >
      {/* Subtotal */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            color: labelColor,
            fontSize: "10px",
            fontWeight:"600",
          }}
        >
          {subtotalLabel}
        </span>
        <span
          style={{
            fontSize: subtotalFontSize,
            fontWeight: subtotalFontWeight,
            color:"#9ca3af"
          }}
        >
          ₺ {subTotal}
        </span>
      </div>

      {/* Total */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: itemGap,
        }}
      >
        <span
          style={{
            fontSize: labelFontSize,
            fontWeight: totalFontWeight,
            color: totalTextColor,
          }}
        >
          {totalLabel}
        </span>
        <span
          style={{
            fontSize: totalFontSize,
            fontWeight: totalFontWeight,
            color: totalTextColor,
          }}
        >
          ₺ {total}
        </span>
      </div>

      {/* divider */}
      {showDividers && (
        <hr
          style={{
            borderTop: `1px solid ${dividerColor}`,
            margin: `${sectionGap} 0`,
            border: "none",
            borderTopWidth: "1px",
            borderTopStyle: "solid",
          }}
        />
      )}

      {/* Coupon Code Header */}
      <div
        onClick={() => collapsibleSections && setCouponOpen((o) => !o)}
        style={{
          display: "flex",
          gap: "1px",
          alignItems: "center",
          cursor: collapsibleSections ? "pointer" : "default",
          userSelect: "none",
          paddingTop: itemGap,
          paddingBottom: itemGap,
        }}
      >
        <span
          style={{
            fontWeight: headerFontWeight,
            fontSize: labelFontSize,
            color: textColor,
          }}
        >
          {hasExistingCoupons ? couponEditLabel : couponAddLabel}
        </span>
        {collapsibleSections && showIcons && (
          <span
            style={{
              color: iconColor,
              fontSize: "16px",
              transform: couponOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: `transform 200ms ease`,
              display: "flex",
              alignItems: "center",
            }}
          >
            <CaretRightIcon size={iconSize} />
          </span>
        )}
      </div>

      {/* Coupon Code Input */}
      <div
        style={{
          overflow: "hidden",
          transition: `all ${animationDuration} ease-in-out`,
          maxHeight: couponOpen || !collapsibleSections ? "80px" : "0",
          opacity: couponOpen || !collapsibleSections ? 1 : 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: itemGap,
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: inputBackgroundColor,
              border: `1px solid ${inputBorderColor}`,
              borderRadius: inputBorderRadius,
              overflow: "hidden",
            }}
          >
            {showIcons && (
              <div style={{ padding: inputPadding }}>
                <TagIcon size={iconSize} color={iconColor} />
              </div>
            )}
            <input
              ref={couponInputRef}
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleApplyCoupon()}
              placeholder={couponPlaceholder}
              disabled={loading || hasExistingCoupons}
              style={{
                flex: 1,
                padding: inputPadding,
                fontSize: inputFontSize,
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                opacity: loading || hasExistingCoupons ? 0.5 : 1,
              }}
            />
            <button
              onClick={handleApplyCoupon}
              disabled={loading || !couponCode.trim() || hasExistingCoupons}
              style={{
                padding: `${inputPadding} ${buttonPadding}`,
                backgroundColor: buttonBackgroundColor,
                color: buttonTextColor,
                fontSize: buttonFontSize,
                cursor: "pointer",
                border: "none",
                opacity:
                  loading || !couponCode.trim() || hasExistingCoupons ? 0.5 : 1,
              }}
            >
              {loading ? loadingText : applyButtonText}
            </button>
          </div>
          <button
            onClick={() => {
              if (hasExistingCoupons) {
                handleRemoveCoupon();
              } else {
                setCouponOpen(false);
              }
            }}
            style={{
              padding: inputPadding,
              color: iconColor,
              fontSize: "14px",
              cursor: "pointer",
              border: "none",
              backgroundColor: "transparent",
            }}
          >
            <XIcon size={iconSize} />
          </button>
        </div>
      </div>

      {/* coupon divider */}
      {showDividers && (
        <hr
          style={{
            borderTop: `1px solid ${dividerColor}`,
            margin: `${sectionGap} 0`,
            border: "none",
            borderTopWidth: "1px",
            borderTopStyle: "solid",
          }}
        />
      )}

      {/* Order Note Header */}
      <div
        onClick={() => collapsibleSections && setNoteOpen((o) => !o)}
        style={{
          display: "flex",
          gap: "1px",
          alignItems: "center",
          cursor: collapsibleSections ? "pointer" : "default",
          userSelect: "none",
          paddingTop: itemGap,
          paddingBottom: itemGap,
          marginTop: "12px",
        }}
      >
        <span
          style={{
            fontWeight: headerFontWeight,
            fontSize: labelFontSize,
            color: textColor,
          }}
        >
          {hasExistingNote ? noteEditLabel : noteAddLabel}
        </span>
        {collapsibleSections && showIcons && (
          <span
            style={{
              color: iconColor,
              fontSize: "16px",
              transform: noteOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: `transform 200ms ease`,
              display: "flex",
              alignItems: "center",
            }}
          >
            <CaretRightIcon size={iconSize} />
          </span>
        )}
      </div>

      {/* Order Note Input */}
      <div
        style={{
          overflow: "hidden",
          transition: `all ${animationDuration} ease-in-out`,
          maxHeight: noteOpen || !collapsibleSections ? "80px" : "0",
          opacity: noteOpen || !collapsibleSections ? 1 : 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            height: textareaHeight,
            alignItems: "flex-start",
            marginTop: itemGap,
          }}
        >
          <textarea
            ref={noteInputRef}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder={notePlaceholder}
            disabled={loading}
            style={{
              height: "100%",
              flex: 1,
              border: `1px solid ${inputBorderColor}`,
              borderRadius: inputBorderRadius,
              padding: inputPadding,
              fontSize: inputFontSize,
              resize: "none",
              outline: "none",
              opacity: loading ? 0.5 : 1,
              backgroundColor: inputBackgroundColor,
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              paddingTop: "3px",
              paddingBottom: "3px",
            }}
          >
            <button
              onClick={() => {
                handleRemoveNote();
              }}
              style={{
                backgroundColor: buttonBackgroundColor,
                borderRadius: buttonBorderRadius,
                marginLeft: "4px",
                padding: inputPadding,
                color: iconColor,
                fontSize: "14px",
                cursor: "pointer",
                border: "none",
              }}
            >
              <XIcon color={buttonTextColor} size={iconSize} />
            </button>
            <button
              onClick={handleApplyNote}
              disabled={loading || !noteText.trim()}
              style={{
                backgroundColor: buttonBackgroundColor,
                borderRadius: buttonBorderRadius,
                marginLeft: "4px",
                padding: inputPadding,
                color: "#10b981",
                fontSize: "14px",
                cursor: "pointer",
                border: "none",
                opacity: loading || !noteText.trim() ? 0.5 : 1,
              }}
            >
              <CheckIcon color={buttonTextColor} size={iconSize} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSummary;
